import React from 'react';

const NotFound = () => {
    return (
        <div className="flex flex-col items-center justify-center h-screen bg-[#EFF0F2]">
            <div className="text-center">
                <div className="flex items-center justify-center w-full">
                    <span className="text-9xl font-bold text-[#C3372E] animate-jump delay-1">4</span>
                    <span className="text-9xl font-bold text-[#C3372E] animate-jump delay-2">0</span>
                    <span className="text-9xl font-bold text-[#C3372E] animate-jump delay-3">4</span>
                </div>
                <p className="text-2xl mt-4 text-[#353A40]">Упс! Эта страница не найдена.</p>
                <p className="mt-2 text-lg text-[#353A40]">Возможно, она была перемещена или удалена.</p>
                <a href="/" className="mt-6 inline-block px-6 py-3 bg-[#C3372E] text-white rounded hover:bg-[#A72A25] transition">
                    Вернуться на главную
                </a>
            </div>
            <div className="animation-container relative w-full h-48 overflow-hidden mt-10">
                <img src='CarHor.png' className="truck w-24 rounded-lg absolute bottom-0 left-[-100px] animate-drive"/>
            </div>
        </div>
    );
}

export default NotFound;
